import { render, staticRenderFns } from "./MonitorDemand.vue?vue&type=template&id=768c228e"
import script from "./MonitorDemand.vue?vue&type=script&lang=js"
export * from "./MonitorDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports